import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "title", "alt"]

import Tooltip from "@premcalc/components/tooltip.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'policyDefinition',
  props: {
    policyDefinition: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Tooltip, {
      tooltip: _ctx.policyDefinition.policyDescription
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: _ctx.policyDefinition.iconPath,
          title: _ctx.policyDefinition.policyName,
          alt: _ctx.policyDefinition.policyTitle
        }, null, 8 /* PROPS */, _hoisted_1),
        _createElementVNode("p", null, _toDisplayString(_ctx.policyDefinition.policyTitle), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["tooltip"])
  ]))
}
}

})